class Cache {
    constructor(ttl = 5 * 60 * 1000) { // Default 5 minutes
        this.cache = new Map();
        this.ttl = ttl;
    }

    get(key) {
        const item = this.cache.get(key);
        if (!item) return null;

        const now = Date.now();
        if (now - item.timestamp > this.ttl) {
            this.cache.delete(key);
            return null;
        }

        return item.data;
    }

    set(key, data) {
        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    delete(key) {
        this.cache.delete(key);
    }

    clear() {
        this.cache.clear();
    }
}

// Create singleton instances for different types of data
export const userCache = new Cache(5 * 60 * 1000); // 5 minutes for user data
export const academyAppCache = new Cache(5 * 60 * 1000); // 5 minutes for academy applications
export const eventsCache = new Cache(15 * 60 * 1000); // 15 minutes for events
export const publicationsCache = new Cache(30 * 60 * 1000); // 30 minutes for publications
export const membersCache = new Cache(5 * 60 * 1000); // 5 minutes for members
export const projectsCache = new Cache(15 * 60 * 1000); // 15 minutes for projects
export const thinkTankCache = new Cache(15 * 60 * 1000); // 15 minutes for think tank data
export const partnershipCache = new Cache(5 * 60 * 1000); // 5 minutes for partnership applications
export const profileCache = new Cache(5 * 60 * 1000); // 5 minutes for profile data
export const homeStatsCache = new Cache(15 * 60 * 1000); // 15 minutes for home stats
export const featuredContentCache = new Cache(30 * 60 * 1000); // 30 minutes for featured content
export const activitiesCache = new Cache(5 * 60 * 1000); // 5 minutes for activities
export const groupsCache = new Cache(15 * 60 * 1000); // 15 minutes for groups
export const clubsCache = new Cache(15 * 60 * 1000); // 15 minutes for clubs 